"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Alert = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lab = require("@material-ui/lab");

var _core = require("@material-ui/core");

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Componente primário de interação com o usuário
 */
var Alert = function Alert(_ref) {
  var children = _ref.children,
      severity = _ref.severity,
      variant = _ref.variant;
  var classes = (0, _styles.useStyles)();
  return /*#__PURE__*/_react.default.createElement(_lab.Alert, {
    classes: classes,
    severity: severity,
    variant: variant
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, " ", children, " "));
};

exports.Alert = Alert;
Alert.propTypes = {
  /**
   * Texto do Alerta (título não incluso)
   */
  children: _propTypes.default.string.isRequired,

  /**
   * Define a cor e o ícone do alerta
   */
  severity: _propTypes.default.oneOf(['error', 'warning', 'info', 'success']).isRequired,

  /**
   * Define a variante do alerta
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined'])
};
Alert.defaultProps = {
  variant: 'standard'
};
var _default = Alert;
exports.default = _default;